let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("k31EC"), load("6E2pS"), load("7YoSv")]).then(() => parcelRequire('3MgcY'));